<template>
<!-- 数据列表 -->
    <div class="el-card pd20">
        <div class="main">
            <div class="box">
                <!--  --> 
                <div class="search">
                     <!--  -->
                    <div class="search-gropu on">
                        提交时间
                        <el-date-picker class="buy-time" v-model="buy_time" type="daterange"  value-format="yyyy-MM-dd"   start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                    </div>
                    <el-button type="primary" @click="pullData" size="medium">搜索</el-button>
                    <el-button type="primary" @click="exportExcelHandle" size="medium">导出数据</el-button>
                </div>
            </div>
            <!-- list-->
            <div class="el-card pd20">
                <el-table v-if="list.length>0" :data="list" show-overflow-tooltip border style="width: 100%">
                    <el-table-column type="index" width="50" label="序号"></el-table-column>
                    <el-table-column v-for="(item,index) in Object.keys(header)" :key="index" :prop="item" >
                        <template v-if="item" slot="header">
                            {{header[item]}}
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- 返回按钮 -->
            <el-button  class="addBtn" size="mini"   @click="$router.go(-1)">返回</el-button>
            <!-- 分页 -->
            <el-pagination class="pages" 
                :page-sizes="[25, 50, 75, 100]"
                @size-change="handleSizeChange" 
                @current-change="handleCurrentChange" 
                :page-size="pages.size" 
                :current-page="pages.page"
                background 
                layout="sizes,prev, pager, next" 
                :total="pages.count"> 
            </el-pagination>
            <!-- -->
        </div>
        
    </div>
</template>

<script>
import { dataList,dataAll} from "@/api/career_college";
import { exportExcel } from "@u/tools";
export default {
    data() {
        return{
            list: [],
            header:{},
            pages: {},
            buy_time:[],
            obj:{}
        }
    },
    methods:{
        headerToColumn(item){
            console.log(item);
            return this.header[item]
        },
        //导出的方法
        exportExcelHandle() {
            let h = [];
            let b =  [];
            if(this.buy_time && this.buy_time.length>0){
                this.obj['start_time'] = this.buy_time[0];//开始时间
                this.obj['end_time'] = this.buy_time[1];//结束时间
            }
            if(this.formId){
                this.obj['table_id'] = this.formId;//表单id
            }
            dataAll({
                table_id:this.obj.table_id,
                begin_time:this.obj.start_time,
                end_time:this.obj.end_time
            }).then((res)=>{
                if(res.error>0){
                    this.$message(res.msg);
                    return
                }
                let list = res.list;  //把data里的tableData存到list
                for (let key of Object.keys(res.header)) {
                    b.push(key);
                    h.push(res.header[key]);
                }
                exportExcel(h,b,list,'表单数据')
			
		    })
            
        },
         // 调整每页显示条数
        handleSizeChange(val) {
            this.pages.size = val;
            this.pullData();
        },
        // 触发分页
        handleCurrentChange(val) {
            this.pages.page = val;
            this.pullData();
        },
        pullData(){
            this.$showLoading();
            this.obj = {
                page:this.pages.page?this.pages.page:1,  //页码，默认1
                size:this.pages.size?this.pages.size:25   //每页数量，默认25
            };
            if(this.buy_time && this.buy_time.length>0){
                this.obj['start_time'] = this.buy_time[0];//开始时间
                this.obj['end_time'] = this.buy_time[1];//结束时间
            }
            if(this.$route.query.id){
                this.obj['table_id'] = this.$route.query.id;//表单id
            }else{
                this.$message('表单ID不能为空！');
                this.$hideLoading();
                return
            }
            

            dataList(this.obj).then((data)=>{
                this.list = data.list;
                this.header = data.header;
                this.pages = data.pager;

                
                this.$hideLoading();
            }).catch((err)=>{
                this.$hideLoading();
            });
        }
    },
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss" scoped>
.main{
  position: relative;
}
.addBtn{
  position: absolute;
  left: 0;
  bottom: 0;
}
.pages{
  text-align: right;
  margin-top: 30px;
}
.pages-box{
    height: 32px;
    margin-top: 30px;
}
.preview{
    width: 300px;
    border-radius: 5px;
}
.box{
    margin-bottom: 20px;
}
.search{
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
}
.search.search-btn{
    flex: 1;
}
.search-gropu{
    flex: 1;
}
.search-gropu.on{
    flex: 1.5;
}
.search-child{
    margin-left: 20px;
    width: 200px;
}
.userinfo{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    img{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 15px;
    }
}
</style>